import { render } from "./CatchTheLetter.vue?vue&type=template&id=a331dd66&scoped=true"
import script from "./CatchTheLetter.vue?vue&type=script&lang=js"
export * from "./CatchTheLetter.vue?vue&type=script&lang=js"

import "./CatchTheLetter.vue?vue&type=style&index=0&id=a331dd66&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a331dd66"]])

export default __exports__